import React from 'react';
import { SignUpContainer } from '../sign-up-container/sign-up-container';
import { GIFS } from '../assets';
import './loading-screen.scss';
export const LoadingScreen = () => {
  return (
    <SignUpContainer>
      <div className="loading-container">
        <img
          src={GIFS.LoaderGif}
          alt="loading"
          height={'120px'}
          width={'120px'}
        />
      </div>
    </SignUpContainer>
  );
};
